<template>
  <Layout>
    <div v-if="model" class="fruit-detail-wrapper">
      <!-- Thanh điều hướng quay lại -->
      <div class="back-navigation-bar">
        <div class="container">
          <button type="button" class="btn-back-nav" @click="goBack">
            <span class="back-icon-circle">
              <span class="isax isax-arrow-left icon-back"></span>
            </span>
            <span class="back-text-label">{{ $t('detail.back_to_list') || 'Quay lại danh sách' }}</span>
          </button>
        </div>
      </div>

      <!-- Hero Header -->
      <section class="hero-section">
        <div class="hero-container">
          <div class="hero-info">
            <div class="badges-row" v-if="activeCertifications && activeCertifications.length > 0">
              <div v-for="(cn, idx) in activeCertifications" :key="idx" class="category-badge">
                <img v-if="cn.files && cn.files.length > 0 && (cn.files[0].fileId || cn.files[0].path)"
                  :src="getImageUrl(cn.files[0])" class="icon-badge-img" />
                <span v-else class="isax isax-verify icon-badge"></span>
                {{ getLangValueFromItem(cn, 'key') }}
              </div>
            </div>
            <div v-else class="category-badge">
              <span class="isax isax-verify icon-badge"></span>
              {{ $t('detail.specialty_category') || 'Danh mục trái cây đặc sản' }}
            </div>
            <h1 class="fruit-name">
              {{ getLangValueFromItem(model, 'name') }} <br />
              <span v-if="model.tenKhoaHoc || tenKhoaHocFallback" class="scientific-name">
                ({{ model.tenKhoaHoc || tenKhoaHocFallback }})
              </span>
            </h1>
            <p class="fruit-brief">
              {{ (getLangValueFromItem(model, 'moTa') || getLangValueFromItem(model, 'dacTinhSinhHoc')) | truncate(220)
              }}
            </p>

            <div class="stats-row">
              <div class="stat-card">
                <span class="isax isax-box icon-stat text-primary"></span>
                <div class="stat-meta">
                  <span class="stat-label">{{ $t('detail.area') || 'Diện tích' }}</span>
                  <span class="stat-value">{{ dicitichVal }}</span>
                </div>
              </div>
              <div class="stat-card">
                <span class="isax isax-bar-graph-1 icon-stat text-primary"></span>
                <div class="stat-meta">
                  <span class="stat-label">{{ $t('detail.yield') || 'Sản lượng' }}</span>
                  <span class="stat-value">{{ sanluongVal }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="hero-media-wrapper">
            <div class="media-accent-bg"></div>
            <img v-if="model.avatar && (model.avatar.fileId || model.avatar.path)" :src="getImageUrl(model.avatar)"
              :alt="getLangValueFromItem(model, 'name')" class="main-image shadow-effect clickable"
              @click="showImg(0, [model.avatar])" />
            <div v-else class="media-placeholder shadow-effect">
              <span class="isax isax-image placeholder-icon"></span>
              <p>{{ $t('detail.updating_images') }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Main Content -->
      <section class="detail-container">
        <div class="grid-layout">
          <!-- Sidebar Trái -->
          <aside class="sidebar-area">
            <div class="specs-card">
              <h3 class="sidebar-card-title">
                <span class="isax isax-info-circle"></span> {{ $t('detail.bio_characteristics') || 'Thông số kỹ thuật'
                }}
              </h3>
              <div class="specs-list">
                <div class="spec-item" v-if="getLangValueFromItem(model, 'dacTinhSinhHoc')">
                  <p class="spec-subtitle">{{ $t('detail.bio_characteristics') || 'Đặc tính sinh học' }}</p>
                  <p class="spec-desc whitespace-pre-wrap">
                    {{ getLangValueFromItem(model, 'dacTinhSinhHoc') }}
                  </p>
                </div>
                <div class="spec-item" v-if="getLangValueFromItem(model, 'ghiChu')">
                  <p class="spec-subtitle">{{ $t('detail.cert_protection') || 'Chứng nhận & Bảo hộ' }}</p>
                  <p class="spec-desc whitespace-pre-wrap">{{ getLangValueFromItem(model, 'ghiChu') }}</p>
                </div>
                <!-- QR Code -->
                <div class="qr-box-wrapper" v-if="model.qrCode2 && (model.qrCode2.path || model.qrCode2.fileId)">
                  <p class="spec-subtitle">{{ $t('detail.qr_view_info') || 'Mã QR xem thông tin' }}</p>
                  <div class="qr-container">
                    <div class="qr-image-wrapper">
                      <img :src="getImageUrl(model.qrCode2)" alt="QR" />
                    </div>
                    <div class="qr-meta">
                      <p class="qr-title">{{ $t('detail.traceability_code') || 'Mã số truy xuất' }}</p>
                      <div class="qr-code-badge">{{ $t('detail.code_label') || 'Mã:' }} {{ model.code }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Gallery -->
              <div class="gallery-section-wrapper" v-if="model.files && model.files.length > 0">
                <h3 class="gallery-title">{{ $t('detail.orchard_photos') || 'Hình ảnh thực tế' }}</h3>
                <div class="photo-grid-layout">
                  <div v-for="(file, index) in model.files" :key="index" class="photo-item"
                    @click="showImg(index, model.files)">
                    <img :src="getImageUrl(file)" class="gallery-img" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Tài liệu đính kèm -->
            <div class="docs-download-card" v-if="model.fileGhiChu && model.fileGhiChu.length > 0">
              <h3 class="sidebar-card-title">
                <span class="isax isax-folder-open"></span> {{ $t('detail.attached_documents') || 'Tài liệu đính kèm' }}
              </h3>
              <div class="docs-list">
                <a v-for="(doc, dIdx) in model.fileGhiChu" :key="dIdx" :href="getImageUrl(doc)" target="_blank"
                  class="doc-download-item">
                  <span class="isax isax-document-text text-danger me-2"></span>
                  <span class="doc-name">{{ doc.fileName }}</span>
                </a>
              </div>
            </div>
          </aside>

          <!-- Right Content -->
          <article class="article-area">
            <!-- Thuộc tính động -->
            <div v-for="(group, gIdx) in sortedThuocTinhs" :key="'group-' + gIdx" class="attribute-group-section mb-5">
              <h3 class="group-category-title">{{ getLangValueFromItem(group, 'key') }}</h3>
              <div class="attributes-grid">
                <div v-for="(val, vIdx) in group.Value" :key="vIdx"
                  :class="['attr-card-item', val.files && val.files.length > 0 ? 'has-images' : '']">
                  <div class="attr-text-content">
                    <h4 class="attr-item-title">{{ getLangValueFromItem(val, 'name') }}</h4>
                    <p class="attr-item-value">{{ getLangValueFromItem(val, 'value') }}</p>
                  </div>
                  <div class="attr-images-gallery" v-if="val.files && val.files.length > 0">
                    <img v-for="(img, i) in val.files" :key="i" :src="getImageUrl(img)"
                      @click="showImg(i, val.files)" />
                  </div>
                </div>
              </div>
            </div>


          </article>
        </div>
      </section>

      <!-- Infographics Section: Giữa trang (dưới Grid thông tin, trên Footer) -->
      <section v-if="currentInfographic" class="infographic-section">
        <div class="infographic-header text-center">
          <h3 class="infographic-title text-heading">
            {{ $t('detail.infographic_title') }}
          </h3>
          <p class="infographic-subtitle-text text-muted">
            {{ $t('detail.infographic_subtitle') }}
          </p>
        </div>
        <div class="infographic-container" @click="showImg(0, [currentInfographic])">
          <img :src="getImageUrl(currentInfographic)" :alt="getLangValueFromItem(model, 'name')"
            class="infographic-image" />
          <div class="infographic-overlay">
            <span class="isax isax-search-zoom-in icon-zoom"></span>
            <p class="overlay-zoom-text">{{ $t('detail.click_to_zoom') }}</p>
          </div>
        </div>
      </section>
    </div>

    <!-- Lightbox phóng to ảnh -->
    <vue-easy-lightbox :visible="lightboxVisible" :imgs="lightboxImages" :index="lightboxIndex"
      @hide="lightboxVisible = false"></vue-easy-lightbox>
  </Layout>
</template>

<script>
import Layout from "@/layouts/layout.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { traiCayModel } from "@/models/profession/traiCay/traiCayModel";

export default {
  name: "FruitDetail",
  components: {
    Layout,
    VueEasyLightbox,
  },
  props: {
    // Nhận dữ liệu traiCayModel động truyền vào từ danh sách ngoài
    fruitData: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      traiCay: traiCayModel.baseJson(),
      tenKhoaHocFallback: "Durio zibethinus L.",
      currentPage: 1,
      perPage: 9,
      lightboxVisible: false,
      lightboxImages: [],
      lightboxIndex: 0,
      apiView: process.env.VUE_APP_API_URL + 'filesminio/view/',
    };
  },
  computed: {
    model() {
      return this.fruitData || this.traiCay;
    },
    activeCertifications() {
      if (!this.model || !Array.isArray(this.model.chungNhan)) return [];
      return this.model.chungNhan.filter(cn => cn.isBool === true);
    },
    // Sắp xếp các nhóm thuộc tính động theo thứ tự (index)
    sortedThuocTinhs() {
      if (!this.model || !this.model.thuocTinhs) return [];
      return [...this.model.thuocTinhs].sort((a, b) => (a.index || 0) - (b.index || 0));
    },
    // Trích xuất số liệu diện tích động bóc tách từ helper
    dicitichVal() {
      if (!this.model) return this.$t('detail.updating') || "Đang cập nhật";
      const val = this.getLangValueFromItem(this.model, 'dienTichSanLuong');
      const [area] = this.splitDienTichSanLuong(val);
      return area;
    },
    // Trích xuất số liệu sản lượng động bóc tách từ helper
    sanluongVal() {
      if (!this.model) return this.$t('detail.updating') || "Đang cập nhật";
      const val = this.getLangValueFromItem(this.model, 'dienTichSanLuong');
      const [, yieldVal] = this.splitDienTichSanLuong(val);
      return yieldVal;
    },
    // Lọc riêng thị trường xuất khẩu
    exportMarketGroups() {
      if (!this.model || !this.model.thuocTinhs) return [];
      return this.model.thuocTinhs.filter(group => {
        const key = (group.key || "").toLowerCase();
        const keyEn = (group.keyEn || "").toLowerCase();
        return key.includes("thị trường xuất khẩu") || key.includes("thi truong xuat khau") || keyEn.includes("export market");
      }).sort((a, b) => (a.index || 0) - (b.index || 0));
    },
    // Lọc các thuộc tính thường còn lại
    otherThuocTinhs() {
      if (!this.model || !this.model.thuocTinhs) return [];
      return this.model.thuocTinhs.filter(group => {
        const key = (group.key || "").toLowerCase();
        const keyEn = (group.keyEn || "").toLowerCase();
        return !(key.includes("thị trường xuất khẩu") || key.includes("thi truong xuat khau") || keyEn.includes("export market"));
      }).sort((a, b) => (a.index || 0) - (b.index || 0));
    },
    currentInfographic() {
      if (!this.model || !this.model.infographics || !Array.isArray(this.model.infographics) || this.model.infographics.length === 0) {
        return null;
      }
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      if (currentLocale === "en") {
        const enInfo = this.model.infographics[1];
        if (enInfo && (enInfo.fileId || enInfo.path)) {
          return enInfo;
        }
      }
      const viInfo = this.model.infographics[0];
      if (viInfo && (viInfo.fileId || viInfo.path)) {
        return viInfo;
      }
      return null;
    },
  },
  filters: {
    // Bộ lọc thu gọn nội dung tóm tắt
    truncate(text, length) {
      if (!text) return "";
      if (text.length <= length) return text;
      return text.substring(0, length) + "...";
    },
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
    if (!this.fruitData && this.$route.params.code) {
      this.getChiTietTraiCay();
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  methods: {
    splitDienTichSanLuong(val) {
      const fallback = this.$t('detail.updating') || "Đang cập nhật";
      if (!val) return [fallback, fallback];

      // 1. Phân tách theo ký tự xuống dòng \n (Đáp ứng JSON mới dạng Xoài Cát Chu)
      if (val.includes('\n')) {
        const parts = val.split('\n');
        return [
          parts[0] ? parts[0].trim() : fallback,
          parts[1] ? parts[1].trim() : fallback
        ];
      }

      // 2. Phân tách theo ký tự gạch chéo / (Đáp ứng định dạng cũ)
      if (val.includes('/')) {
        const parts = val.split('/');
        return [
          parts[0] ? parts[0].trim() : fallback,
          parts[1] ? parts[1].trim() : fallback
        ];
      }

      // 3. Sử dụng Regex thông minh bóc tách nếu chuỗi viết liền kề (Ví dụ: "tỉnh 224.300")
      const match = val.match(/(.+?\s)(?=\b\d+[\d.,]*\s+[a-zA-ZÀ-ỹ])/);
      if (match && match[1]) {
        const first = match[1].trim();
        const second = val.substring(match[1].length).trim();
        return [first, second];
      }

      return [val, fallback];
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        const query = {};
        if (this.$route.query.embed) query.embed = this.$route.query.embed;
        if (this.$route.query.iframe) query.iframe = this.$route.query.iframe;
        this.$router.push({ path: '/trai-cay/danh-sach', query });
      }
    },
    getLangValue(fieldName) {
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      return currentLocale === "en" ? `${fieldName}En` : fieldName;
    },
    getLangValueFromItem(item, fieldName) {
      if (!item) return "";
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      if (currentLocale === "en") {
        const enField = `${fieldName}En`;
        return item[enField] || item[fieldName] || "";
      }
      return item[fieldName] || "";
    },
    async getChiTietTraiCay() {
      try {
        await this.$store
          .dispatch("profession/traiCay/traiCayStore/getByCode", this.$route.params.code)
          .then((res) => {
            if (res && res.data) {
              this.traiCay = traiCayModel.fromJson(res.data);
            }
          });

        console.info('Mã QR trái cây link: ', this.apiView + this.traiCay?.qrCode2.fileId)
      } catch (err) {
        console.error("Lỗi khi fetch chi tiết sản phẩm:", err);
      }
    },

    showImg(index, files) {
      if (!files || files.length === 0) return;
      this.lightboxImages = files.map((file) => this.getImageUrl(file));
      this.lightboxIndex = index;
      this.lightboxVisible = true;
    },
    getImageUrl(file) {
      if (!file) return "";
      if (file.fileId) {
        return `${process.env.VUE_APP_API_URL}filesminio/view/${file.fileId}`;
      }
      return file.path || "";
    },
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (navbar) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky");
        } else {
          navbar.classList.remove("nav-sticky");
        }
      }
    },
  },
};
</script>

<style scoped>
/* ======================== CHỦ ĐỀ MÀU SẮC & PHÔNG CHỮ CHUNG ======================== */
.fruit-detail-wrapper {
  font-family: var(--font-body-standard), sans-serif;
  color: var(--on-surface, #181d17);
  background-color: var(--background, #f7fbf0);
  line-height: 1.6;
}

/* ======================== REDESIGNED BACK NAVIGATION ======================== */
.back-navigation-bar {
  padding: 1.71rem 0 0 0;
  background-color: rgba(27, 94, 32, 0.05);
  text-align: left;
}

@media (max-width: 576px) {
  .back-navigation-bar {
    padding: 1rem 0 0 0;
  }
}

.btn-back-nav {
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  background: #ffffff;
  border: 1px solid var(--outline-variant, #bfcaba);
  padding: 0.57rem 1.14rem 0.57rem 0.85rem;
  border-radius: 714.28rem;
  color: var(--color-public-primary, #2e7d32);
  font-family: var(--font-heading-admin), sans-serif;
  font-weight: 700;
  font-size: 0.92rem;
  cursor: pointer;
  outline: none;
  box-shadow: 0 0.14rem 0.57rem rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@media (max-width: 576px) {
  .btn-back-nav {
    padding: 0.43rem 0.85rem 0.43rem 0.57rem;
    font-size: 0.85rem;
    gap: 0.57rem;
  }
}

.back-icon-circle {
  width: 2rem;
  height: 2rem;
  background-color: rgba(46, 125, 50, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@media (max-width: 576px) {
  .back-icon-circle {
    width: 1.71rem;
    height: 1.71rem;
  }
}

.icon-back {
  font-size: 1rem;
  transition: transform 0.2s ease;
}

@media (max-width: 576px) {
  .icon-back {
    font-size: 0.85rem;
  }
}

.back-text-label {
  letter-spacing: 0.02em;
}

.btn-back-nav:hover {
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border-color: var(--color-public-primary, #2e7d32);
  box-shadow: 0 0.28rem 0.85rem rgba(46, 125, 50, 0.15);
  transform: translateX(-0.28rem);
}

.btn-back-nav:hover .back-icon-circle {
  background-color: rgba(255, 255, 255, 0.2);
}

.btn-back-nav:hover .icon-back {
  transform: translateX(-0.14rem);
}


/* ======================== HERO SECTION (HEADER BANNER) ======================== */
.hero-section {
  background: linear-gradient(180deg,
      rgba(27, 94, 32, 0.05) 0%,
      rgba(27, 94, 32, 0) 100%);
  padding: 1.14rem 1.14rem 2.28rem 1.14rem;
}

@media (min-width: 768px) {
  .hero-section {
    padding: 1.42rem 1.71rem 2.85rem 1.71rem;
  }
}

.hero-container {
  max-width: var(--container-max, 1280px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.71rem;
  align-items: center;
}

@media (min-width: 992px) {
  .hero-container {
    flex-direction: row;
    padding: 1.42rem 2.85rem;
    gap: 2.28rem;
  }
}

.hero-info {
  flex: 1;
  text-align: left;
}

/* Badge Danh mục */
.badges-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.71rem;
  margin-bottom: 1.71rem;
}

.badges-row .category-badge {
  margin-bottom: 0;
}

.category-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.57rem;
  padding: 0.43rem 1.14rem;
  background-color: #a3f69c;
  color: #002204;
  border-radius: 714.28rem;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1.71rem;
}

.icon-badge-img {
  width: 1.2rem;
  height: 1.2rem;
  object-fit: contain;
  border-radius: 4px;
}

.icon-badge {
  font-size: 1.14rem;
}

/* Tên Trái cây và Tên Khoa học */
.fruit-name {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 2.28rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 1.14rem;
}

@media (min-width: 768px) {
  .fruit-name {
    font-size: 3.42rem;
  }
}

.scientific-name {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 1.71rem;
  color: var(--secondary, #8f4e00);
  font-weight: 600;
  font-style: italic;
}

.fruit-brief {
  font-size: 1.14rem;
  color: var(--on-surface-variant, #40493d);
  max-width: 45.71rem;
  margin-bottom: 2.28rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Số dòng tối đa bạn muốn hiển thị */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Thống kê nhanh */
.stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.14rem;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 1.14rem;
  background-color: var(--surface-container, #ebefe5);
  padding: 1.14rem;
  border-radius: 0.85rem;
  border: 1px solid var(--outline-variant, #bfcaba);
  flex: 1 1 calc(50% - 0.57rem);
  min-width: 10rem;
}

.icon-stat {
  font-size: 2rem;
  color: var(--primary, #0d631b);
}

.stat-meta {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--on-surface-variant, #40493d);
}

.stat-value {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.42rem;
  font-weight: 700;
  color: var(--primary, #0d631b);
}

/* Khung Ảnh đại diện bên phải */
.hero-media-wrapper {
  position: relative;
  width: 100%;
  max-width: 42rem;
}

@media (min-width: 992px) {
  .hero-media-wrapper {
    width: 50%;
  }
}

.media-accent-bg {
  position: absolute;
  inset: -1.14rem;
  background-color: rgba(13, 99, 27, 0.08);
  border-radius: 2.28rem;
  filter: blur(1.14rem);
}

.main-image {
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 2.28rem;
  transition: transform 0.5s ease;
}

.main-image:hover {
  transform: scale(1.01);
}

.media-placeholder {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background-color: var(--surface-container-high, #e5eadf);
  border: 2px dashed var(--outline-variant, #bfcaba);
  border-radius: 2.28rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--on-surface-variant, #40493d);
  font-weight: 600;
}

.placeholder-icon {
  font-size: 3.42rem;
  margin-bottom: 0.57rem;
}

.shadow-effect {
  box-shadow: 0 1.42rem 1.78rem -0.35rem rgba(0, 0, 0, 0.1), 0 0.71rem 0.71rem -0.35rem rgba(0, 0, 0, 0.04);
}

.clickable {
  cursor: pointer;
}

/* ======================== BỐ CỤC ASYMMETRIC CHÍNH ======================== */
.detail-container {
  max-width: var(--container-max, 1280px);
  margin: 1.71rem auto 0 auto;
  padding: 0 1.14rem;
}

@media (min-width: 768px) {
  .detail-container {
    margin-top: 3.42rem;
    padding: 0 1.71rem;
  }
}

@media (min-width: 992px) {
  .detail-container {
    margin-top: 4.57rem;
    padding: 0 2.85rem;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.71rem;
}

@media (min-width: 992px) {
  .grid-layout {
    gap: 2.85rem;
  }
}

/* CỘT SIDEBAR TRÁI (6 CỘT) */
.sidebar-area {
  grid-column: span 12;
  text-align: left;
}

@media (min-width: 992px) {
  .sidebar-area {
    grid-column: span 6;
  }
}

.specs-card {
  background-color: var(--surface-cream, #fff8e1);
  padding: 1.42rem;
  border-radius: 1.14rem;
  border: 1px solid rgba(187, 202, 186, 0.3);
  margin-bottom: 1.71rem;
}

@media (min-width: 768px) {
  .specs-card {
    padding: 2.28rem;
    border-radius: 1.71rem;
    margin-bottom: 2.28rem;
  }
}

.sidebar-card-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.42rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.57rem;
  margin-bottom: 1.71rem;
}

.specs-list {
  display: flex;
  flex-direction: column;
  gap: 1.14rem;
}

.spec-item {
  padding-bottom: 1.14rem;
  border-bottom: 1px solid var(--outline-variant, #bfcaba);
}

.spec-item:last-child {
  border-bottom: none;
}

.spec-subtitle {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--secondary, #8f4e00);
  margin-bottom: 0.28rem;
}

.spec-desc {
  font-size: 1rem;
  color: var(--on-surface-variant, #40493d);
  margin: 0;
}

.whitespace-pre-wrap {
  white-space: pre-wrap;
}

/* Khung QR Code */
.qr-box-wrapper {
  padding-top: 0.57rem;
}

.qr-container {
  background-color: #ffffff;
  padding: 1.14rem;
  border-radius: 0.85rem;
  border: 1px solid var(--outline-variant, #bfcaba);
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media (max-width: 480px) {
  .qr-container {
    flex-direction: column;
    text-align: center;
    gap: 1.14rem;
  }
}

.qr-image-wrapper {
  width: 6.85rem;
  height: 6.85rem;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 0.57rem;
  padding: 0.28rem;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.qr-image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-meta {
  margin-left: 1.14rem;
  flex-grow: 1;
}

@media (max-width: 480px) {
  .qr-meta {
    margin-left: 0;
  }
}

.qr-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--color-public-text-head, #1b5e20);
  margin: 0 0 0.28rem 0;
}

.qr-desc {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 0.78rem;
  color: var(--on-surface-variant, #40493d);
  line-height: 1.4;
  margin: 0;
}

.qr-code-badge {
  display: inline-block;
  font-family: monospace;
  font-size: 0.71rem;
  font-weight: bold;
  background-color: rgba(143, 78, 0, 0.1);
  color: var(--secondary, #8f4e00);
  padding: 0.14rem 0.43rem;
  border-radius: 0.28rem;
  margin-top: 0.43rem;
}

/* Thẻ vùng trồng tập trung */
.vung-trong-card {
  background-color: var(--surface-container-high, #e5eadf);
  padding: 1.42rem;
  border-radius: 1.14rem;
}

@media (min-width: 768px) {
  .vung-trong-card {
    padding: 2.28rem;
    border-radius: 1.71rem;
  }
}

.vung-trong-desc {
  font-size: 1rem;
  color: var(--on-surface-variant, #40493d);
  line-height: 1.6;
  margin: 0;
}

/* CỘT NỘI DUNG CHÍNH BÊN PHẢI (6 CỘT) */
.article-area {
  grid-column: span 12;
  text-align: left;
}

@media (min-width: 992px) {
  .article-area {
    grid-column: span 6;
  }
}

/* Album ảnh thực tế tại vườn */
.gallery-section-wrapper {
  margin-top: 1.71rem;
  padding-top: 1.71rem;
  border-top: 1px solid var(--outline-variant, #bfcaba);
}

.gallery-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.42rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
  margin-bottom: 1.71rem;
}

/* Photo Grid Layout: Bento-style */
.photo-grid-layout {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.14rem;
}

@media (min-width: 576px) {
  .photo-grid-layout {
    grid-template-columns: repeat(3, 1fr);
  }
}

.photo-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 1.14rem;
  overflow: hidden;
  cursor: pointer;
}

.photo-large {
  grid-column: span 2;
  aspect-ratio: 1.79;
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.photo-item:hover .gallery-img {
  transform: scale(1.08);
}

.photo-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 50%, rgba(0, 0, 0, 0.7) 100%);
  display: flex;
  align-items: flex-end;
  padding: 1.14rem;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.photo-item:hover .photo-overlay {
  opacity: 1;
}

.overlay-text {
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 700;
  margin: 0;
}

/* ======================== BẢNG THỊ TRƯỜNG XUẤT KHẨU & THUỘC TÍNH ĐỘNG ======================== */
.docs-download-card {
  background-color: var(--surface-cream, #fff8e1);
  padding: 1.42rem;
  border-radius: 1.14rem;
  border: 1px solid rgba(187, 202, 186, 0.3);
  margin-top: 1.71rem;
}

@media (min-width: 768px) {
  .docs-download-card {
    padding: 2.28rem;
    border-radius: 1.71rem;
    margin-top: 2.28rem;
  }
}

.docs-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.doc-download-item {
  display: flex;
  align-items: center;
  padding: 0.85rem 1.14rem;
  background-color: #ffffff;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 0.85rem;
  text-decoration: none;
  color: var(--on-surface, #1c1d1a);
  transition: all 0.3s ease;
}

.doc-download-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: var(--primary, #0d631b);
  color: var(--primary, #0d631b);
}

.doc-name {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attribute-group-section {
  text-align: left;
}

.group-category-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.42rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
  margin-bottom: 1.42rem;
  position: relative;
  padding-bottom: 0.57rem;
}

.group-category-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 3.5rem;
  height: 3px;
  background-color: var(--primary, #0d631b);
  border-radius: 2px;
}

.attributes-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.14rem;
}

@media (min-width: 768px) {
  .attributes-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.attr-card-item {
  background-color: #ffffff;
  border: 1px solid rgba(187, 202, 186, 0.3);
  border-radius: 1.14rem;
  padding: 1.14rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.14rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.attr-card-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

@media (min-width: 768px) {
  .attr-card-item.has-images {
    grid-column: span 2;
    flex-direction: row;
    align-items: center;
  }
}

.attr-text-content {
  flex: 1;
  text-align: left;
}

.attr-item-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.07rem;
  color: var(--secondary, #8f4e00);
  font-weight: 700;
  margin: 0 0 0.43rem 0;
}

.attr-item-value {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 0.95rem;
  color: var(--on-surface-variant, #40493d);
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
}

.attr-images-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 0.57rem;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .attr-images-gallery {
    max-width: 50%;
  }
}

.attr-images-gallery img {
  width: 4.85rem;
  height: 4.85rem;
  object-fit: cover;
  border-radius: 0.57rem;
  cursor: pointer;
  border: 1px solid var(--outline-variant, #bfcaba);
  transition: transform 0.2s;
}

.attr-images-gallery img:hover {
  transform: scale(1.05);
}

/* ======================== INFOGRAPHIC SECTION ======================== */
.infographic-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
  /* margin-bottom: 3rem; */
  padding: 1.14rem 10px 2.5rem 10px;
}

.infographic-header {
  margin-bottom: 2rem;
  max-width: 50rem;
}

.infographic-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.71rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
}

.infographic-subtitle-text {
  font-size: 1rem;
  margin-top: 0.5rem;
}

.infographic-container {
  max-width: 720px;
  width: 100%;
  aspect-ratio: 720 / 960;
  border-radius: 1.14rem;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--outline-variant, #bfcaba);
  background-color: var(--surface-container, #ebefe5);
  cursor: pointer;
  position: relative;
}

.infographic-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.5s ease;
}

.infographic-container:hover .infographic-image {
  transform: scale(1.02);
}

.infographic-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.infographic-container:hover .infographic-overlay {
  opacity: 1;
}

.icon-zoom {
  font-size: 2.5rem;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.overlay-zoom-text {
  color: #ffffff;
  font-family: var(--font-heading-organic), sans-serif;
  font-weight: 700;
  font-size: 1rem;
  margin: 0;
}
</style>